import { render, staticRenderFns } from "./CdkImageDetailProvider.vue?vue&type=template&id=218505f8&scoped=true&"
import script from "./CdkImageDetailProvider.vue?vue&type=script&lang=ts&"
export * from "./CdkImageDetailProvider.vue?vue&type=script&lang=ts&"
import style0 from "./CdkImageDetailProvider.vue?vue&type=style&index=0&id=218505f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218505f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
